<homey-page-title title="Forgot password"/>
<p class="mb-4">Enter your email and we'll send you a link to get back into your account.</p>
@if (error()) {
  <p-message icon="pi pi-times-circle" severity="error" class="block mb-4">
    {{ error() }}
  </p-message>
}
<homey-custom-form [formGroup]="form" submitButtonLabel="Send" [submitFunction]="submit">
  <homey-text-input [inputFormControl]="form.controls.email"
                    inputId="email"
                    label="Email address"
                    type="email"/>
</homey-custom-form>
